import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-846c545a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ark-one-strategy-page" }
const _hoisted_2 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-spinner" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "加载中...", -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "page-content"
}
const _hoisted_7 = { class: "header-section" }
const _hoisted_8 = { class: "main-section" }
const _hoisted_9 = { class: "left-section" }
const _hoisted_10 = { class: "performance-section" }
const _hoisted_11 = { class: "right-section" }
const _hoisted_12 = { class: "tabs-section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StrategyHeader = _resolveComponent("StrategyHeader")!
  const _component_PerformanceChart = _resolveComponent("PerformanceChart")!
  const _component_CapitalDistribution = _resolveComponent("CapitalDistribution")!
  const _component_PositionDistribution = _resolveComponent("PositionDistribution")!
  const _component_PositionTabs = _resolveComponent("PositionTabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_StrategyHeader, {
              name: _ctx.portfolioData?.name || '',
              tags: _ctx.portfolioData?.tags || [],
              highlights: _ctx.portfolioData?.highlights || '',
              language: _ctx.language,
              theme: _ctx.theme
            }, null, 8, ["name", "tags", "highlights", "language", "theme"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_PerformanceChart, {
                  data: _ctx.performanceData,
                  "time-range": _ctx.selectedTimeRange,
                  "rebalancing-dates": _ctx.rebalancingDates,
                  "annualized-return": _ctx.portfolioData?.annualizedReturn || 0,
                  "total-return": _ctx.portfolioData?.totalReturn || 0,
                  "total-dividend-yield": _ctx.portfolioData?.totalDividendYield || 0,
                  "color-mode": _ctx.colorMode,
                  language: _ctx.language,
                  theme: _ctx.theme,
                  onTimeRangeChange: _ctx.handleTimeRangeChange,
                  onRebalancingMarkerClick: _ctx.handleRebalancingMarkerClick
                }, null, 8, ["data", "time-range", "rebalancing-dates", "annualized-return", "total-return", "total-dividend-yield", "color-mode", "language", "theme", "onTimeRangeChange", "onRebalancingMarkerClick"])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_CapitalDistribution, {
                distribution: _ctx.portfolioData?.capitalDistribution || { stocks: 0, etf: 0, cash: 0, other: 0 },
                language: _ctx.language,
                theme: _ctx.theme
              }, null, 8, ["distribution", "language", "theme"]),
              _createVNode(_component_PositionDistribution, {
                positions: _ctx.portfolioData?.positionDistribution || [],
                language: _ctx.language,
                theme: _ctx.theme
              }, null, 8, ["positions", "language", "theme"])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_PositionTabs, {
              positions: _ctx.positions,
              "selected-date": _ctx.selectedRebalancingDate || undefined,
              "color-mode": _ctx.colorMode,
              language: _ctx.language,
              theme: _ctx.theme,
              "hk-delay": _ctx.hkDelay,
              "us-delay": _ctx.usDelay,
              onOrderClick: _ctx.handleOrder,
              onRowDoubleClick: _ctx.handleStockDetailNavigation
            }, null, 8, ["positions", "selected-date", "color-mode", "language", "theme", "hk-delay", "us-delay", "onOrderClick", "onRowDoubleClick"])
          ])
        ]))
  ]))
}